import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Close } from '@material-ui/icons';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles';
import { Paper, TextField, Grid, InputAdornment, CircularProgress, Typography, Divider, AppBar, Toolbar, IconButton, FormControl, RadioGroup, Radio, FormControlLabel, FormLabel } from '@material-ui/core/';
import { NumberOfFollowers } from '../../Config/numberOfFollowers';
import { Context } from '../../Context';
import Moment from 'react-moment';
import moment from 'moment';

import MobileStepper from '@material-ui/core/MobileStepper';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { FlowWizard } from '../common/FlowWizard';
import { Basic } from './Basic';
import { Profile } from './Profile';
import { Instructions } from './Instructions';
import { Identity } from './Identity';
import { ReviewAndSend } from './ReviewAndSend';
import { required, minLength, checkAnyEquals, greaterThan } from '../../Utils/validation';

const styles = (theme) => ({
	dialogPaper: {
		// minHeight: '75vh'
		position: 'relative',
	},
	stepper: {
		margin: theme.spacing.unit,
		position: "fixed",
		bottom: theme.spacing.unit,
	},
	closeButton: {
		marginLeft: -20
	},
	typography: {
		marginBottom: 10
	},
	wrapper: {
		position: 'relative'
	},
	buttonProgress: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: -9,
		marginLeft: -9
	},
	submit: {
		marginTop: theme.spacing.unit * 2,
		marginBottom: theme.spacing.unit
	}
});

const steps = [
	{
		name: 'Setup campaign basics',
		component: Basic,
		props: {
		},
		initialValues: {
			budget: 3000,
			autoPilot: true,
			campaignName: '',
			goLiveDateType: 'today',
			goLiveStartDate: moment().add(10, 'days'),
			goLiveEndDate: moment().add(40, 'days'),

		},
		validationSchema: {
			campaignName: { validate: [{ validator: required, message: 'Please enter a campaign name.' }] },
			goLiveStartDate: { validate: [{ validator: greaterThan('goLiveEndDate', 'goLiveStartDate'), message: 'Start date must be before end date' }] },
			goLiveEndDate: { validate: [{ validator: greaterThan('goLiveEndDate', 'goLiveStartDate'), message: 'End date must be after start date' }] },
		}
	},
	{
		name: 'Choose a target audience',
		component: Profile,
		props: {
		},
		initialValues: {
			minFolowers: 1000,
			maxFolowers: 10000,
			selectedCountries: [],
			selectedInterests: []
		},
		validationSchema: {
			selectedCountries: { validate: [{ validator: minLength(1), message: 'Please select at least one country.' }] },
			selectedInterests: { validate: [{ validator: minLength(1), message: 'Please select at least one interest.' }] },
		}
	},
	{
		name: 'Add campaign instructions',
		component: Instructions,
		props: {
		},
		initialValues: {
			promoteByPost: true,
			promoteByStory: true,
			promoteByVideo: false,
			brief: '',
			sendGift: false,
			campaignURL: '',
			hashtagsAndMentions: '',
			discountCode: ''
		},
		validationSchema: {
			promoteByPost: { validate: [{ validator: checkAnyEquals(['promoteByPost', 'promoteByStory'], true), message: 'Please pick at least one.' }] },
			promoteByStory: { validate: [{ validator: checkAnyEquals(['promoteByPost', 'promoteByStory'], true), message: 'Please pick at least one.' }] },
			brief: { validate: [{ validator: required, message: 'Please enter a campaign brief.' }] },
		}
	},
	{
		name: 'Describe your brand and product(s)',
		component: Identity,
		props: {
		},
		initialValues: {
			identity: '',
			brandWebsite: '',
			brandInstagramHandle: '',
			productImageURL: ''

		},
		validationSchema: {
		}
	},
	{
		name: 'Review and submit',
		component: ReviewAndSend,
		props: {
		},
		initialValues: {
		},
		validationSchema: {
		}
	},
];


const CreateCampaignScreen = (props) => {

	const context = useContext(Context);

	console.log("CreateCompaign Screen", props);
	const { handleDialogClose, fullScreen, open, classes } = props;
	const handleSubmit = (values) => {

		const campaign = {
			name: values.campaignName,
			product: {
				// productName: this.state.productName,
				productImageURL: values.productImageURL,
				// productDescription: this.state.productDescription
			},
			// 	demographics: this.state.demographics,
			// 	caption: caption,
			campaignURL: values.campaignURL,
			followers: {
				min: values.minFolowers,
				max: values.maxFolowers
			},
			targetDemographics: {
				countries: values.selectedCountries,
				interests: values.selectedInterests,
				additionalInfo: values.additionalInfo
			},
			sendGift: values.sendGift,
			promotionType: {
				post: values.promoteByPost,
				story: values.promoteByStory,
				video: values.promoteByVideo
			},
			description: values.identity,
			instagramHandle: values.brandInstagramHandle,
			brandWebsite: values.brandWebsite,
			brief: values.brief,
			autopilot: values.autoPilot,
			goLiveDate: values.goLiveStartDate,
			continuous: values.goLiveDateType === 'today',
			endDate: values.goLiveDateType === 'today' ? null : values.goLiveEndDate,
			hashtagsAndMentions: values.hashtagsAndMentions,
			discountCode: values.discountCode,
			budget: {
				budget: parseInt(values.budget, 10)
			}

		};

		context.actions.createAdvertiserCampaign(campaign, () => {
			handleDialogClose();
		});


	};


	return (
		<div>
			<Dialog
				fullScreen={fullScreen}
				fullWidth={true}
				open={open}
				onClose={handleDialogClose}
				scroll='paper'
				aria-labelledby="Create a new campaign"
				maxWidth='lg'
				classes={{ paper: classes.dialogPaper }}
			>
				<AppBar position='static'>
					<Toolbar disableGutters>
						<IconButton color="inherit" onClick={handleDialogClose} aria-label="Close">
							<Close />
						</IconButton>
						<Typography variant="h6" color="inherit">
							Create a new campaign
						</Typography>
					</Toolbar>
				</AppBar>
				<FlowWizard
					showMobile={props.showMobile}
					steps={steps}
					onSubmit={handleSubmit}
				/>
			</Dialog>
		</div>
	)
}

CreateCampaignScreen.propTypes = {
	fullScreen: PropTypes.bool.isRequired
};
// CreateCampaignScreen.contextType = Context;
const CreateCampaignReactive = withMobileDialog()(CreateCampaignScreen);

export const CreateCampaign = withStyles(styles)(CreateCampaignReactive);

// class CreateCampaign extends React.Component {
// 	constructor() {
// 		super();
// 		this.state = this.getInitialState();
// 	}

// 	getInitialState = () => {
// 		const initialState = {
// 			captionType: 'auto',
// 			hashtagType: 'auto',

// 			captionValue: '',
// 			hashtagValue: '',

// 			goLiveDateType: 'asap',
// 			goLiveDate: moment().add(5, 'days'),

// 			goLiveError: false,
// 			captionError: false,
// 			hashtagError: false,

// 			productName: '',
// 			productNameError: false,

// 			min: 1000,
// 			max: 100000,
// 			minMaxError: false,
// 			demographics: '',

// 			name: '',
// 			nameError: false,

// 			error: false,

// 			budget: 500,
// 			budgetError: false
// 		};
// 		return initialState;
// 	}

// 	handleClose = () => {
// 		this.setState(this.getInitialState());
// 		this.props.handleDialogClose();
// 	};

// 	handleCreate = () => {
// 		this.setState({
// 			error: false,
// 			nameError: false,
// 			productNameError: false,
// 			hashtagError: false,
// 			captionError: false,
// 			goLiveError: false,
// 			minMaxError: false,
// 			budgetError: false
// 		}, () => {
// 			let errorCheck = false;
// 			if (!this.state.name) {
// 				errorCheck = true;
// 				this.setState({
// 					error: true,
// 					nameError: true
// 				});
// 			}
// 			if (!this.state.productName) {
// 				errorCheck = true;
// 				this.setState({
// 					error: true,
// 					productNameError: true
// 				});
// 			}
// 			if (this.state.captionType !== 'auto' && !this.state.captionValue) {
// 				errorCheck = true;
// 				this.setState({
// 					error: true,
// 					captionError: true
// 				});
// 			}
// 			if (this.state.hashtagType !== 'auto' && !this.state.hashtagValue) {
// 				errorCheck = true;
// 				this.setState({
// 					error: true,
// 					hashtagError: true
// 				});
// 			}
// 			if (!this.state.goLiveDate) {
// 				errorCheck = true;
// 				this.setState({
// 					error: true,
// 					goLiveError: true
// 				});
// 			}
// 			if (parseInt(this.state.min) >= parseInt(this.state.max) && !(parseInt(this.state.min) === 100001 && parseInt(this.state.max) === 100001)) {
// 				errorCheck = true;
// 				this.setState({
// 					error: true,
// 					minMaxError: true
// 				});
// 			}
// 			if (!this.state.budget || parseInt(this.state.budget) < 100 || parseInt(this.state.budget) > 20000) {
// 				errorCheck = true;
// 				this.setState({
// 					error: true,
// 					budgetError: true
// 				});
// 			}

// 			if (!errorCheck) {
// 				let caption = {};
// 				if (this.state.captionType === 'auto') {
// 					caption = { auto: true }
// 				} else if (this.state.captionType === 'include') {
// 					caption = { include: this.state.captionValue }
// 				} else {
// 					caption = { exact: this.state.captionValue }
// 				}

// 				let hashtags = {};
// 				if (this.state.hashtagsType === 'auto') {
// 					hashtags = { auto: true }
// 				} else if (this.state.hashtagsType === 'include') {
// 					hashtags = { include: this.state.hashtagValue }
// 				} else {
// 					hashtags = { exact: this.state.hashtagValue }
// 				}

// 				const campaign = {
// 					name: this.state.name,
// 					product: {
// 						productName: this.state.productName,
// 						productImageURL: this.state.productImageURL,
// 						productDescription: this.state.productDescription
// 					},
// 					campaignURL: this.state.campaignURL,
// 					followers: {
// 						min: this.state.min,
// 						max: this.state.max
// 					},
// 					demographics: this.state.demographics,
// 					goLiveDate: this.state.goLiveDate,
// 					caption: caption,
// 					hashtags: hashtags,
// 					budget: {
// 						budget: parseInt(this.state.budget)
// 					}
// 				};

// 				this.context.actions.createAdvertiserCampaign(campaign, () => {
// 					if (!this.context.state.error) {
// 						this.handleClose();
// 					}
// 				});
// 			}
// 		});
// 	}

// 	handleCaptionChange = (event) => {
// 		this.setState({ captionType: event.target.value });
// 	};

// 	handleHashtagChange = (event) => {
// 		this.setState({ hashtagType: event.target.value });
// 	};

// 	handleChange = name => event => {
// 		let value = event.target.value;
// 		if (typeof event.target.value === 'string' && event.target.type !== 'radio') {
// 			value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)
// 		}
// 		this.setState({
// 			[name]: value
// 		});
// 	}

// 	render() {
// 		const { fullScreen } = this.props;
// 		const { classes } = this.props;

// 		return (
// 			<div>
// 				<Dialog
// 					fullScreen={fullScreen}
// 					fullWidth={true}
// 					open={this.props.open}
// 					onClose={this.handleClose}
// 					scroll='paper'
// 					aria-labelledby="Create a new campaign"
// 					maxWidth='sm'
// 				>
// 					<AppBar position='static'>
// 						<Toolbar>
// 							<IconButton color="inherit" onClick={this.handleClose} aria-label="Close" className={classes.closeButton}>
// 								<Close />
// 							</IconButton>
// 							<Typography variant="h6" color="inherit" className={classes.flex}>
// 								Create a new campaign
//               				</Typography>
// 						</Toolbar>
// 					</AppBar>
// 					<Divider style={{ marginBottom: 20 }} />
// 					<DialogContent>
// 						<Grid container spacing={16}>
// 							<Grid item xs={12}>
// 								<Typography variant="h6">
// 									Let's give this campaign a name!
// 								</Typography>
// 								<TextField
// 									label="Campaign name"
// 									value={this.state.name}
// 									onChange={this.handleChange('name')}
// 									fullWidth
// 									autoFocus
// 									margin="normal"
// 									variant="outlined"
// 									required={true}
// 									error={this.state.nameError}
// 									helperText={this.state.nameError ? 'Please enter a campaign name' : ''}
// 								/>
// 								<Typography variant="h6" className={classes.typography}>
// 									What would this campaign be about?
// 								</Typography>
// 								<FormLabel component="legend">
// 									Tell us a few more details about what you are advertising.
// 								</FormLabel>
// 								<TextField
// 									label="Name of your product or brand"
// 									value={this.state.productName}
// 									onChange={this.handleChange('productName')}
// 									fullWidth
// 									margin="normal"
// 									variant="outlined"
// 									required={true}
// 									error={this.state.productNameError}
// 									helperText={this.state.productNameError ? 'Please enter a product or brand name' : ''}
// 								/>
// 								<TextField
// 									label="More details about your product or brand"
// 									value={this.state.productDescription}
// 									onChange={this.handleChange('productDescription')}
// 									fullWidth
// 									multiline
// 									rows={2}
// 									margin="normal"
// 									variant="outlined"
// 								/>
// 								<TextField
// 									label="Product or brand image URLs"
// 									value={this.state.productImageURL}
// 									onChange={this.handleChange('productImageURL')}
// 									fullWidth
// 									margin="normal"
// 									variant="outlined"
// 									helperText="Please paste URLs to image(s) of your product or brand"
// 								/>
// 								<TextField
// 									label="Campaign URL"
// 									value={this.state.campaignURL}
// 									onChange={this.handleChange('campaignURL')}
// 									fullWidth
// 									margin="normal"
// 									variant="outlined"
// 									helperText="To which URL would you like to drive the traffic"
// 								/>
// 							</Grid>
// 							<Grid item xs={12}>
// 								<Typography variant="h6" className={classes.typography}>
// 									What kind of budget are you planning?
// 								</Typography>
// 								<FormLabel component="legend">
// 									Set the maximum budget you want to allocate on this campaign
// 								</FormLabel>
// 								<TextField
// 									fullWidth
// 									label="Budget"
// 									margin="normal"
// 									type="number"
// 									variant="outlined"
// 									value={this.state.budget}
// 									onChange={this.handleChange('budget')}
// 									InputProps={{
// 										startAdornment: <InputAdornment position="start">£</InputAdornment>,
// 										inputProps: {
// 											min: 100,
// 											max: 20000,
// 											step: 100
// 										}
// 									}}
// 									error={this.state.budgetError}
// 									helperText={this.state.budgetError ? 'Please enter a budget estimate £100 and £20,000' : ''}>
// 								</TextField>
// 							</Grid>
// 							<Grid item xs={12}>
// 								<Typography variant="h6" className={classes.typography}>
// 									What kind of influencers should promote your product?
// 								</Typography>
// 								<FormLabel component="legend">
// 									Number of followers:
// 								</FormLabel>
// 							</Grid>
// 							<Grid item xs={12} sm={6}>
// 								<TextField
// 									select
// 									fullWidth
// 									label="Min followers"
// 									SelectProps={{
// 										native: true
// 									}}
// 									margin="normal"
// 									variant="outlined"
// 									defaultValue={1000}
// 									onChange={this.handleChange('min')}
// 								>
// 									{NumberOfFollowers.map(option => (
// 										<option key={option.label} value={option.value}>
// 											{option.label}
// 										</option>
// 									))}
// 								</TextField>
// 							</Grid>
// 							<Grid item xs={12} sm={6}>
// 								<TextField
// 									select
// 									fullWidth
// 									label="Max followers"
// 									SelectProps={{
// 										native: true
// 									}}
// 									margin="normal"
// 									variant="outlined"
// 									defaultValue={100000}
// 									onChange={this.handleChange('max')}
// 								>
// 									{NumberOfFollowers.map(option => (
// 										<option key={option.label} value={option.value}>
// 											{option.label}
// 										</option>
// 									))}
// 								</TextField>
// 							</Grid>
// 							{this.state.minMaxError && (
// 								<Grid item xs={12}>
// 									<Typography variant="subtitle1" color='primary'>
// 										Please make sure the maximum number of followers is greater than the minimum
// 									</Typography>
// 								</Grid>
// 							)}
// 							{/* <Grid item xs={12}>
// 								<FormLabel component="legend">
// 									Demographics:
// 								</FormLabel>
// 							</Grid> */}
// 							<Grid item xs={12}>
// 								<TextField
// 									label='Demographics'
// 									helperText="Location and characteristics of the influencer. For example “mommybloggers in UK”"
// 									value={this.state.demographics}
// 									onChange={this.handleChange('demographics')}
// 									fullWidth
// 									margin="normal"
// 									variant="outlined"
// 								/>
// 							</Grid>
// 							<Grid item xs={12}>
// 								<Typography variant="h6">
// 									What do you want them to say?
// 								</Typography>
// 								<FormControl component="fieldset">
// 									<RadioGroup
// 										aria-label="caption"
// 										name="caption"
// 										value={this.state.captionType}
// 										onChange={this.handleCaptionChange}
// 									>
// 										<FormControlLabel value="auto" control={<Radio color='primary' />} label="Let the people decide!" />
// 										<FormControlLabel value="include" control={<Radio color='primary' />} label="Include at least the following..." />
// 										<FormControlLabel value="exact" control={<Radio color='primary' />} label="Use this exact caption (not recommended)..." />
// 									</RadioGroup>
// 								</FormControl>
// 								{this.state.captionType !== 'auto' && (
// 									<TextField
// 										label="What is the caption?"
// 										required={true}
// 										value={this.state.captionValue}
// 										onChange={this.handleChange('captionValue')}
// 										fullWidth
// 										margin="normal"
// 										variant="outlined"
// 										error={this.state.captionError}
// 										helperText={this.state.captionError ? 'Please enter a caption, for example: 20% off with the code VIMMA' : 'For example: 20% off with the code VIMMA'}
// 									/>
// 								)}
// 							</Grid>
// 							<Grid item xs={12}>
// 								<Typography variant="h6">
// 									Hashtags and mentions?
// 								</Typography>
// 								<FormControl component="fieldset">
// 									<RadioGroup
// 										aria-label="caption"
// 										name="caption"
// 										value={this.state.hashtagType}
// 										onChange={this.handleHashtagChange}
// 									>
// 										<FormControlLabel value="auto" control={<Radio color='primary' />} label="Let the people decide!" />
// 										<FormControlLabel value="include" control={<Radio color='primary' />} label="Use at least these hashtags and mentions..." />
// 										<FormControlLabel value="exact" control={<Radio color='primary' />} label="Use only these hashtags and mentions (not recommended)..." />
// 									</RadioGroup>
// 								</FormControl>
// 								{this.state.hashtagType !== 'auto' && (
// 									<TextField
// 										label="Enter hashtags and mentions"
// 										required={true}
// 										value={this.state.hashtagValue}
// 										onChange={this.handleChange('hashtagValue')}
// 										fullWidth
// 										margin="normal"
// 										variant="outlined"
// 										error={this.state.hashtagError}
// 										helperText={this.state.hashtagError ? 'Please enter a caption, for example: #vimma @mention' : 'For example: #vimma @mention'}
// 									/>
// 								)}
// 							</Grid>
// 							<Grid item xs={12}>
// 								<Typography variant="h6" className={classes.typography}>
// 									When do you want the ads posted?
// 								</Typography>
// 								<FormControl component="fieldset">
// 									<FormLabel component="legend">
// 										The earliest possible date is <Moment format='MMMM Do YYYY'>
// 											{moment().add(5, 'days')}
// 										</Moment>.
// 									</FormLabel>
// 									<RadioGroup
// 										aria-label="caption"
// 										name="caption"
// 										value={this.state.goLiveDateType}
// 										onChange={this.handleChange('goLiveDateType')}
// 									>
// 										<FormControlLabel value="asap" control={<Radio color='primary' />} label="ASAP!" />
// 										<FormControlLabel value="date" control={<Radio color='primary' />} label="On a specific date..." />
// 									</RadioGroup>
// 								</FormControl>
// 								{this.state.goLiveDateType === 'date' && (
// 									<TextField
// 										label="Go Live Date"
// 										type="date"
// 										fullWidth
// 										onChange={this.handleChange('goLiveDate')}
// 										variant="outlined"
// 										required={true}
// 										value={moment(this.state.goLiveDate).format('YYYY-MM-DD')}
// 										InputLabelProps={{
// 											shrink: true,
// 										}}
// 										InputProps={{ inputProps: { min: moment().add(10, 'days').format('YYYY-MM-DD'), max: moment().add(3, 'months').format('YYYY-MM-DD') } }}
// 										error={this.state.goLiveError}
// 										helperText='Please set a date at least 10 days from today'
// 									/>
// 								)}
// 							</Grid>
// 							{this.state.error && (
// 								<Grid item xs={12}>
// 									<Typography variant="subtitle1" color='primary'>
// 										Please fill in all the required fields and try again
// 									</Typography>
// 								</Grid>
// 							)}
// 						</Grid>
// 					</DialogContent>
// 					<DialogActions>
// 						<Button onClick={this.handleClose} color="primary" disabled={this.context.state.loading}>
// 							Cancel
// 							</Button>
// 						<div className={classes.wrapper}>
// 							<Button onClick={this.handleCreate} color="primary" disabled={this.context.state.loading}>
// 								Create
// 							</Button>
// 							{this.context.state.loading && <CircularProgress size={16} className={classes.buttonProgress} />}
// 						</div>
// 					</DialogActions>
// 				</Dialog>
// 			</div>
// 		);
// 	}
// }

// CreateCampaign.propTypes = {
// 	fullScreen: PropTypes.bool.isRequired
// };
// CreateCampaign.contextType = Context;
// const CreateCampaignReactive = withMobileDialog()(CreateCampaign);
// export default withStyles(styles)(CreateCampaignReactive);